export default __webpack_public_path__ + "static/media/rif-id-manager-gray.d70174d8.svg";